module.exports = __webpack_public_path__ + "img/img-box-products-magento-2x-left.3f9537fa.png";